import React from "react";
import "./styles/ItCarbonNeutralCity.scss";
import { useTranslation } from "react-i18next";

const ItCarbonNeutralCity = () => {
  const { t } = useTranslation();
  const example = t("it.decarbonization.city.example", { returnObjects: true }) as string[];
  const tech = t("it.decarbonization.city.tech", { returnObjects: true }) as string[];
  const erpPlan = t("it.decarbonization.erp.contents", { returnObjects: true }) as { img_path: string; name: string; text: string }[];
  return (
    <>
      <div className="it_carbon_neutral_city_wrap">
        <div className="city_wrap">
          <h2>{t("it.decarbonization.city.title")}</h2>
          <div className="content">
            <div className="des">{t("it.decarbonization.city.des")}</div>
            <div className="circle_wrap">
              {example.map((text: string, index: number) => {
                return (
                  <div className="circle" key={`${text}_${index}`}>
                    <div className="img_box">
                      <img src="/imgs/step_circle.png" alt="circle" />
                    </div>
                    <span>{text}</span>
                  </div>
                );
              })}
            </div>
            <div className="tech_wrap">
              {tech.map((text: string, index: number) => {
                return (
                  <div className="box" key={`${text}_${index}`}>
                    {text}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="erp_wrap">
          <h2>{t("it.decarbonization.erp.title")}</h2>
          <div className="content">
            <img className="cycle" src="/imgs/erp_framework_01.png" alt="erp_framework_img" />
            <img className="cycle_row" src="/imgs/erp_framework_01_.png" alt="erp_framework_img" />
            <div className="step_wrap">
              <ul className="step_list">
                {erpPlan.map((content: { img_path: string; name: string; text: string }, index: number) => {
                  return (
                    <li key={`${content.name}_${index}`}>
                      <div className="step">
                        <div className="left">
                          <div className="img_box">
                            <img src={content.img_path} alt="erp step image" />
                          </div>
                        </div>
                        <div className="right">
                          <div className="name">{content.name}</div>
                          {content.text !== "" ? (
                            <ul>
                              <li className="text">{content.text}</li>
                            </ul>
                          ) : null}
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ItCarbonNeutralCity;
